/**
 * CMS preview mode.
 *
 * The CMS embeds this site in an iframe and passes a short-lived token on the URL.
 */

export const PREVIEW_TOKEN_PARAM = 'preview_token'

let cachedSearch = null
let cachedToken = null

export function getPreviewToken() {
  if (typeof window === 'undefined') return null

  const currentSearch = window.location.search
  if (currentSearch === cachedSearch) {
    return cachedToken
  }

  const params = new URLSearchParams(currentSearch)
  cachedToken = params.get(PREVIEW_TOKEN_PARAM) || null
  cachedSearch = currentSearch

  return cachedToken
}

export function isPreviewMode() {
  return !!getPreviewToken()
}

export function getPreviewTokenForRoute(route) {
  if (typeof window === 'undefined') return null
  const path = window.location.pathname.replace(/\/+$/, '')
  return path === route ? getPreviewToken() : null
}

export function lockPreviewInteractions() {
  if (typeof window === 'undefined' || !isPreviewMode()) return () => {}

  const block = (event) => {
    const target = event.target
    if (target instanceof Element && target.closest('[data-preview-allow]')) return

    event.preventDefault()
    event.stopPropagation()
    event.stopImmediatePropagation()
  }

  const blockEnter = (event) => {
    if (event.key === 'Enter') block(event)
  }

  const blurEditable = (event) => {
    const el = event.target
    if (
      el instanceof HTMLElement &&
      (el.isContentEditable || el.matches('input, textarea, select'))
    ) {
      el.blur()
    }
  }

  const blockedEvents = ['click', 'auxclick', 'dblclick', 'submit']
  blockedEvents.forEach((type) => window.addEventListener(type, block, true))
  window.addEventListener('keydown', blockEnter, true)
  window.addEventListener('focusin', blurEditable, true)

  const style = document.createElement('style')
  style.setAttribute('data-preview-lock', '')
  style.textContent =
    '* { cursor: default !important; }' +
    ' [data-preview-allow], [data-preview-allow] * { cursor: pointer !important; }'
  document.head.appendChild(style)

  return () => {
    blockedEvents.forEach((type) => window.removeEventListener(type, block, true))
    window.removeEventListener('keydown', blockEnter, true)
    window.removeEventListener('focusin', blurEditable, true)
    style.remove()
  }
}


export function notifyPreviewReady() {
  if (typeof window === 'undefined') return
  if (!isPreviewMode()) return
  if (window.parent === window) return

  try {
    window.parent.postMessage({ type: 'eu-preview-ready' }, '*')
  } catch (e) {
    // Nothing to recover - the CMS falls back to the iframe's own load event.
  }
}
